import { createSlice } from "@reduxjs/toolkit";
import { checkAuth, updateUser, updateUserPassword } from "../actions/authActions";

const authSlice = createSlice({
  name: "auth",
  initialState: {
    token: null,
    isAuthenticated: false,
    user: null,
    loading: false,
    error: null,
  },
  reducers: {
    login(state, action) {
      state.token = action.payload;
      state.isAuthenticated = true;
      state.user = action.payload.data ?? action.payload; 

    },
    logout(state) {
      state.token = null;
      state.isAuthenticated = false;
      state.user = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Verifica autenticação
      .addCase(checkAuth.fulfilled, (state, action) => {
        state.token = action.payload.token;
        state.isAuthenticated = action.payload.isAuthenticated;
        state.user = action.payload.user;
      })
      // Atualizar usuário
      .addCase(updateUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateUser.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload.data ?? action.payload; 
      })
      .addCase(updateUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Atualizar senha
      .addCase(updateUserPassword.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateUserPassword.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(updateUserPassword.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { login, logout } = authSlice.actions;
export default authSlice.reducer;
